module.exports = __webpack_public_path__ + "img/911-c27b06.png";